module.exports = __webpack_public_path__ + "static/logo-570f16c7c3ab52d91e95320ced097380.png";